<template>
  <span :class="elementCss">{{ elementText }}</span>
</template>

<script>
import { Status } from '@/util/constants/Status';
import moment from 'moment';

// private function
// heavily coupled with momentjs
const useMapDate = (start, end, date) => {
  const hasStartDate = !!start;
  const hasEndDate = !!end;
  const hasDateRange = hasStartDate && hasEndDate;

  let startDate = null;

  if (hasStartDate) {
    startDate = moment(new Date(start));
  }

  let endDate = null;

  if (hasEndDate) {
    endDate = moment(new Date(end));
  }

  let isExpired = false;
  let isPending = false;
  if (hasDateRange) {
    const myDate = moment(date);
    isExpired = myDate.isAfter(endDate, 'day');
    isPending = startDate.isAfter(myDate, 'day');
  }

 
  const isWeeksAway = (weeks = 4) => {
    if (!hasEndDate) return false;

    const weeksAhead = moment(date).add(weeks, 'weeks');

    // inclusive day-level comparison
    return weeksAhead.isSameOrAfter(endDate, 'day');
  };

  return {
    hasStartDate,
    hasEndDate,
    hasDateRange,
    startDate,
    endDate,
    isExpired,
    isPending,
    isWeeksAway
  };
};

export default {
  props: {
    organisation: {
      type: Object,
      required: false
    },
    isBiosecurity: {
      type: [Object, Boolean],
      required: false
    }
  },
  data() {
    return {
      Status,
      elementCss: '',
      elementText: ''
    };
  },
  mounted() {
    const { elementCss, elementText } = this.generateElementBlock();
    this.elementCss = elementCss;
    this.elementText = elementText;
  },
  methods: {
    generateElementBlock() {
      const DEFAULT = {
        elementCss: 'badge-danger',
        elementText: ''
      };

      let additionalCss = '';
      let elementText = '';
      
      if(this.organisation) {
        const { contractStart, contractEnd, status } = this.organisation;
        const currentDate = new Date();

        const { isExpired, isWeeksAway, hasDateRange } = useMapDate(contractStart, contractEnd, currentDate);

        const isActive = status === Status.ACTIVE;
        const isPending = status === Status.PENDING;

        if ((contractStart !== undefined || contractEnd !== undefined) && isActive) {
          if (isActive && !hasDateRange) {
            additionalCss = 'badge-secondary';
            elementText = 'No contract';
          } else if (isActive && isExpired) {
            additionalCss = 'badge-orange';
            elementText = 'Contract expired';
          } else if (isActive && isWeeksAway(4)) {
            additionalCss = 'badge-yellow';
            elementText = 'Requires renewal';
          } else if (isActive && isPending) {
            additionalCss = 'badge-orange';
            elementText = 'Contract pending';
          } else if (isActive) {
            additionalCss = 'badge-success';
            elementText = status;
          }
        } else if (isActive) {
          additionalCss = 'badge-success';
          elementText = status;
        } else if (isPending) {
          additionalCss = 'badge-warning';
          elementText = status;
        } else {
          additionalCss = DEFAULT.elementCss;
          elementText = DEFAULT.elementText;
        }
      }
      if((this.isBiosecurity && this.isBiosecurity != 'null') || this.isBiosecurity === 'true') {
        additionalCss = 'badge-success';
        elementText = 'Biosecurity';
      }
      return {
        elementCss: ['badge', additionalCss],
        elementText
      };
    }
  }
};
</script>

<style scoped>
.badge-orange {
  background: orange;
  color: #fff;
}

.badge-yellow {
  background: #fdda0d;
}
</style>
